import { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import Home from './pages/Home';
import OrderProduct from './pages/OrderProduct';
import {useDocTitle} from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import { Helmet } from "react-helmet";

<Helmet>
  <title>Pendik Evden Eve Nakliyat – Sigortalı & Asansörlü Taşıma | Huzurlu Taşin</title>
  <meta name="description" content="Pendik evden eve Huzurlu Taşin şehir içi ve şehirlerarası profesyonel taşımacılık hizmetleri sunar. Güvenli ve zamanında taşıma çözümleri için hemen bizimle iletişime geçin!" />
  <meta name="keywords" content=" Pendik evden eve nakliyat, taşımacılık, evden eve nakliyat, huzurlu Taşin" />
  <meta name="description" content="Istanbul bölgesinde sigortalı, garantili evden eve nakliyat. Ücretsiz ekspertiz, uygun fiyat ve asansörlü taşıma hizmeti."/>
  <meta name="keywords" content="Pendik evden eve nakliyat, pendik evden eve nakliyat, sigortalı nakliye, asansörlü taşımacılık"/>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "MovingCompany",
        "name": "Huzurlu Taşin",
        "image": "https://www.huzurlutasin.com/logo.svg",
        "url": "https://www.huzurlutasin.com/",
        "telephone": "+90 539 380 14 69",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Fevzi Çakmak, Yener Sokağı 7 C, 34890 Pendik/İstanbul",
          "addressLocality": "İstanbul",
          "postalCode": "34890",
          "addressCountry": "TR"
        },
        "openingHours": "Mo-Sa 08:00-19:00",
        "priceRange": "$$",
        "sameAs": [
          "https://www.facebook.com/share/1aM9k7oGdq/?mibextid=wwXIfr",
          "https://www.instagram.com/huzurlutasin/?utm_source=ig_web_button_share_sheet"
        ]
      }
    `}
  </script> 
</Helmet>

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    }

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle("Pendik Huzurlu Taşin Eve Nakliyat ve Depolama");

  return (
    <>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/get-demo" element={<OrderProduct />} /> 
          </Routes>
        </ScrollToTop>
      </Router>
    </>
  );
}


export default App;
